// src/utils/modalUtils.ts

/**
 * Utilitário para gerenciar modais Bootstrap corretamente
 */
export const modalUtils = {
    /**
     * Limpa todos os efeitos de modal (backdrops e estilos do body)
     */
    limparEfeitosModal: () => {
        // Remover backdrops
        document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove());

        // Restaurar estilos do body
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
    },

    /**
     * Fecha um modal e limpa seus efeitos
     * @param idModal - ID do elemento modal a ser fechado
     * @param callback - Função opcional executada após o fechamento
     */
    fecharModal: (idModal: string, callback?: () => void) => {
        const modalElement = document.getElementById(idModal);

        // Função de limpeza que será chamada após fechar o modal
        const limparElementosModal = () => {
            modalUtils.limparEfeitosModal();
            if (callback) callback();
        };

        if (modalElement && typeof window !== 'undefined') {
            // Usando Modal do Bootstrap
            if (typeof window.bootstrap !== 'undefined' && window.bootstrap.Modal) {
                const modalInstance = window.bootstrap.Modal.getInstance(modalElement);

                if (modalInstance) {
                    // Adicionar evento para executar limpeza após fechamento
                    modalElement.addEventListener('hidden.bs.modal', limparElementosModal, { once: true });
                    modalInstance.hide();
                } else {
                    limparElementosModal();
                }
            }
            // Para projetos que importam o Modal a partir de 'bootstrap'
            else {
                try {
                    // Tentativa de usar Modal através de importação dinâmica
                    import('bootstrap').then((bootstrap) => {
                        if (bootstrap && bootstrap.Modal) {
                            const modalInstance = bootstrap.Modal.getInstance(modalElement);
                            if (modalInstance) {
                                modalElement.addEventListener('hidden.bs.modal', limparElementosModal, { once: true });
                                modalInstance.hide();
                            } else {
                                limparElementosModal();
                            }
                        } else {
                            limparElementosModal();
                        }
                    }).catch(() => {
                        // Se falhar ao importar, apenas limpa
                        limparElementosModal();
                    });
                } catch (error) {
                    limparElementosModal();
                }
            }
        } else {
            limparElementosModal();
        }

        // Garantir que a limpeza seja feita de qualquer forma
        setTimeout(limparElementosModal, 300);
    },

    /**
     * Abre um modal com segurança, limpando quaisquer modais abertos anteriormente
     * @param idModal - ID do elemento modal a ser aberto
     */
    abrirModal: (idModal: string) => {
        // Limpar qualquer modal que possa estar aberto
        modalUtils.limparEfeitosModal();

        // Pequeno delay para garantir que tudo foi limpo
        setTimeout(() => {
            const modalElement = document.getElementById(idModal);

            if (modalElement && typeof window !== 'undefined') {
                // Usando Modal do Bootstrap na janela global
                if (typeof window.bootstrap !== 'undefined' && window.bootstrap.Modal) {
                    const modalInstance = new window.bootstrap.Modal(modalElement);
                    modalInstance.show();
                }
                // Para projetos que importam o Modal a partir de 'bootstrap'
                else {
                    try {
                        import('bootstrap').then((bootstrap) => {
                            if (bootstrap && bootstrap.Modal) {
                                const modalInstance = new bootstrap.Modal(modalElement);
                                modalInstance.show();
                            }
                        }).catch(() => {
                            console.error('Não foi possível carregar o Modal do Bootstrap');
                        });
                    } catch (error) {
                        console.error('Erro ao tentar abrir modal:', error);
                    }
                }
            }
        }, 100);
    }
};

// Declaração para TypeScript
declare global {
    interface Window {
        bootstrap?: {
            Modal: any;
        };
    }
}